'use strict';

(function ($) {

    $.fn.tagName = function () {
        return this.prop('tagName').toLowerCase();
    };

    var FORM_TYPE = {
        NATURAL: 'natural',
        REDIRECT: 'redirect',
        INJECTION: 'injection'
    };

    var ALERT_SUCCESS = 'success';
    var ALERT_ERROR = 'error';

    /**
     * Define a value for the hidden input #tz-offset in Form
     */
    function initTimezone() {
        $('#tz-offset').value = new Date().getTimezoneOffset() / -60; //Set timezone in Form
    }

    /**
     * Show the spinner
     * @param {Object} eltForm The Form
     * @param {Object} loaderFor The spinner element if it's outside the Form (bdc)
     * @param {Object} submitGroup The element that owns the loaderFor element
     */
    function displaySpinner(eltForm, loaderFor, submitGroup) {
        if (eltForm.find('.loading-box')) {
            eltForm.find('.loading-box').addClass('active');
        }
        if (eltForm.find('input[type="submit"]')) {
            eltForm.find('input[type="submit"]').hide();
        }
        // Looking for a spinner outside the Form...
        if (loaderFor) {
            loaderFor.addClass('active');
        }
        // Looking for a groupSubmit outside the Form...
        if (submitGroup) {
            submitGroup.hide();
        }
    }

    /**
     * Hide the spinner
     * @param {Object} eltForm The Form
     * @param {Object} loaderFor The spinner element if it's outside the Form (bdc)
     * @param {Object} submitGroup The element that owns the loaderFor element
     */
    function hideSpinner(eltForm, loaderFor, submitGroup) {
        if (eltForm.find('.loading-box')) {
            eltForm.find('.loading-box').removeClass('active');
        }
        if (eltForm.find('input[type="submit"]')) {
            eltForm.find('input[type="submit"]').show();
        }
        // Looking for a spinner outside the Form...
        if (loaderFor) {
            loaderFor.removeClass('active');
        }
        // Looking for a groupSubmit outside the Form...
        if (submitGroup) {
            submitGroup.show();
        }
    }


    /**
     * Show an alert
     * @param {?} alertType
     * @param {Object} eltForm The Form
     * @param {String} msg The message to display
     */
    function displayAlert(alertType, eltForm, msg) {
        $('#alert').remove();

        var closeButton = '<button type="button" class="close" aria-label="Close" onclick="$(\'#alert\').remove();">' +
            '<span aria-hidden="true">&times;</span></button>';

        var SUCCESS_HTML = '<div class="alert alert-success" id="alert" role="alert">' +
                closeButton + msg + '</div>',
            ERROR_HTML = '<div class="alert alert-danger" id="alert" role="alert">' +
                closeButton + msg + '</div>';

        switch (alertType) {
            case ALERT_SUCCESS:
                eltForm.prepend(SUCCESS_HTML);
                break;
            case ALERT_ERROR:
                eltForm.prepend(ERROR_HTML);
                break;
        }
    }

    /**
     * Show a formated message into elements with error-header class
     * @param {String} msg The message to display
     */
    function displayErrorHeader(msg) {
        msg = (msg) ? msg : '';
        $('.error-header').append('<span>' + msg + '</span><br/>').addClass('in error').fadeIn();
    }

    /**
     * Empty each elements with error-header class
     */
    function removeErrorHeader() {
        $('.error-header').empty();
    }

    /**
     * Attach a Foundation tooltip to the specify element, and display a message
     * @param {JQuery} elt The anchor where to attach the tooltip
     * @param {String} msg The message to display inside the tooltip
     */
    function displayTip(elt, msg) {
        var options = {
            tipText: msg,
            templateClasses: 'tooltip--error formTooltip'
        };

        elt.addClass('has-tip');
        // if the input already have a tooltip
        var uuidTooltip = elt.data('toggle');
        if (uuidTooltip){
            $('#' + uuidTooltip).html(msg);
        }  else {
            var tip = new Foundation.Tooltip(elt, options); /* jshint ignore: line */
        }

    }

    /**
     * Hide every error messages and destroy Foundation tooltips
     */
    function hideTips() {
        $('.error').removeClass('error');
        $('span.error-subline').remove();
        $('.has-tip').removeClass('has-tip');
    }

    /**
     * Clear the Form from errors and tooltips
     */
    function clearForm() {
        removeErrorHeader();
        hideTips();
    }

    /**
     * Scroll back to the error header or the first Form element who as an error
     */
    function scrollToFirstError() {
        var position = $('.error');
        $('html, body').stop().animate({
            scrollTop: position.first().offset().top -15
        }, 300, function(){
            $('#sidebarform').stop().animate({
                scrollTop: position.first().position().top + 100
            }, 300);
        });
    }

    function ProcessForm(event, eltForm) {
        var self = this;

        self.data = {};
        self.eltForm = eltForm;

        // Looking for a spinner outside the Form...
        if ($('window').find('.loading-box[for="' + eltForm.attr('id') + '"]')) {
            self.loaderFor = $('.loading-box[for="' + eltForm.attr('id') + '"]');
        }
        // Looking for a groupSubmit outside the Form...
        if ($('window').find('.submitGroup[for="' + eltForm.attr('id') + '"]')) {
            self.submitGroup = $('.submitGroup[for="' + eltForm.attr('id') + '"]');
        }

        var formError = eltForm.attr('data-form-error');
        if (formError) {
            var eltErrorForm = self.eltErrorForm = $(formError);
            switch (eltErrorForm.tagName()) {
                case 'div':
                    eltErrorForm
                        .hide()
                        .find('.errorItem')
                        .remove();
            }
        }

        self.submit(event);
    }


    ProcessForm.prototype.submit = function () {
        var self = this;
        var eltForm = self.eltForm;
        var loaderFor = self.loaderFor;
        var submitGroup = self.submitGroup;

        displaySpinner(eltForm, loaderFor, submitGroup);

        self.strPlacement = 'bottom';

        if (eltForm.attr('data-form-type') === FORM_TYPE.NATURAL) {
            return;
        }

        // Extract the form fields values.
        var jsonBody = eltForm.serializeJSON();

        if(eltForm.attr('data-form-content')) jsonBody.formContent = eltForm.attr('data-form-content').split(' ');
        if(eltForm.attr('data-form-bind')) jsonBody.formBind = eltForm.attr('data-form-bind').split(' ');

        self.formType = eltForm.attr('data-form-type');
        self.formAlert = true;

        $.post(
            eltForm.attr('action'),
            jsonBody,
            function () { clearForm(); },
            'json'
        ).done(
            function (res) { self.done(res); }
        ).fail(
            function () { self.fail(); }
        );
    };

    ProcessForm.prototype.done = function (res) {
        var self = this;
        var error = res.errors;
        var success = res.success;
        var eltForm = self.eltForm;
        var loaderFor = self.loaderFor;
        var submitGroup = self.submitGroup;
        var eltErrorForm = self.eltErrorForm;
        var strPlacement = self.strPlacement;

        hideSpinner(eltForm, loaderFor, submitGroup);

        if (success && self.formAlert) {
            displayAlert(ALERT_SUCCESS, eltForm, success.msg);
        }

        if (error) {
            if ($.isArray(error)) {
                var errormap = {};
                $.each(error, function (i) {
                    var input = error[i].path;
                    var msg = error[i].message;
                    msg = $('<div>').text(msg).html();

                    // Show only the first error for the same input
                    if (errormap[input] == null) { errormap[input] = true; } else { return; }

                    if (input) {
                        if (input.indexOf('.') !== -1) {
                            input = input.replace('.', '[') + ']';
                        }

                        var elmt = eltForm
                            .find(
                                $('input[name="' + input + '"], select[name="' + input + '"], textarea[name="' +
                                    input + '"], label[name="' + input + '"], div[name="' + input + '"]')
                            );

                        if (elmt.length) {
                            elmt.parent().addClass('error');

                            if (elmt.next().hasClass('formGroup')) {
                                elmt.next()
                                    .find($('input, select, textarea')).each(function () {
                                        displayErrorHeader(msg);
                                    });
                            }


                            if (elmt.attr('type') === 'checkbox') {
                                elmt.parent()
                                    .append('<span class="error-subline">' + msg + '</span>')
                                    .addClass('error');
                            } else {
                                displayErrorHeader(msg);
                            }
                        } else {
                            displayErrorHeader(msg);
                        }
                    } else {
                        displayErrorHeader(msg);
                    }
                });

                scrollToFirstError();

                eltForm.trigger('hasErrors');
                return;
            }

            if (eltErrorForm) {
                if (self.formAlert) {
                    displayAlert(ALERT_ERROR, eltForm, error);
                } else {
                    switch (eltErrorForm.tagName()) {
                        case 'div':
                            eltErrorForm
                                .append('<span class="errorItem">' + error + '</span>')
                                .addClass('in')
                                .fadeIn();
                            break;
                        case 'input':
                        case 'select':
                            eltErrorForm
                                .attr('title', error)
                                .attr('data-strPlacement', strPlacement)
                                .addClass('not-validated')
                                .tooltip('show');
                            break;
                    }
                }
            }
            return;
        } else {
            clearForm();
        }

        var formType = self.formType || FORM_TYPE.NATURAL;
        switch (formType) {
            case FORM_TYPE.REDIRECT:
                $(location).attr('href', (res.redirect) ? res.url : res.page); /* jshint ignore: line */
                break;
            case FORM_TYPE.INJECTION:
                if (!(res instanceof Array)) {
                    res = [res];
                }
                res.forEach(function (elt) {
                    $(elt.bind).html(elt.content);
                });
                break;
            case FORM_TYPE.NATURAL:
                break;
            default:
                break;
        }
    };

    ProcessForm.prototype.fail = function () {
        var self = this;
        var eltForm = self.eltForm;
        var loaderFor = self.loaderFor;
        var submitGroup = self.submitGroup;

        hideSpinner(eltForm, loaderFor, submitGroup);

        if (self.eltErrorForm) {
            clearForm();
            displayErrorHeader('There is an error, please try again !');
        }
    };

    $(document).ready(function () { /* jshint ignore: line */
        initTimezone();

        var formSelector = 'form[data-form-type!='+FORM_TYPE.NATURAL+']';
        $(document).on('submit', formSelector, function (event) {
            event.preventDefault();
            return new ProcessForm(event, $(this));
        });
    });

    // window.decodeParams = function (settings) { /* jshint ignore: line */
    //     var data = settings.data || '';
    //     var params = data.split('&');
    //     var obj = {};
    //
    //     params.forEach(function (param) {
    //         if (param.indexOf('=') < 0) {
    //             return;
    //         }
    //         var values = param.split('=');
    //         obj[values[0]] = values[1];
    //     });
    //     return obj;
    // };
}(jQuery)); /* jshint ignore: line */
